import Vue from "vue";
import HeroSlider from "scripts/vue/hero-slider/HeroSlider.vue";
import ProjectsCarousel from "scripts/vue/projects-carousel/ProjectsCarousel.vue";
import ProjectsMap from "scripts/vue/projects-map/ProjectsMap.vue";

export default {
  init() {
    new Vue({
      el: "#app",
      name: "app",
      components: {
        HeroSlider,
        ProjectsCarousel,
        ProjectsMap
      }
    });
  },
  finalize() {}
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js